import React, { useState, useEffect, useRef } from "react";
import { fabric } from "fabric";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { addToCart } from "../../redux/actions/addToCartAction";
import { fontFamilyData } from "../../data/fontFamily";
import { randomColors } from "../../data/colors";
import { cardData } from "../../data/cardData";
import { logoData } from "../../data/logoData";
import { ribbonTails } from "../../data/tailsData";
import { clipartData } from "../../data/clipartData";
import StepOne from "./stepOne";
import StepTwo from "./stepTwo";
import PMSColor from "./pmsColor";
import PMSColorRibbonTwo from "./pmsColorRibbonTwo";
import RosetteFitting from "./rosetteFitting";
import ProductPrice from "./productPrice";
import LeadTimeNotice from "./changingColor";
import PrintLayout from "./printLayout";
import PrintRibbonTail from "./ribbonTail";
import PMSColorRibbonThree from "./pmsColorRibbonThree";
import design_ribbon from "../../../src/assets/svg/logo/Design-Your-Perfect-Ribbon.png";
import Sparkles from "./sparkles";

fabric.TextCurved = fabric.util.createClass(fabric.Object, {
  type: "text-curved",
  diameter: 250,
  kerning: 0,
  text: "",
  flipped: false,
  fill: "#000",
  fontFamily: "Times New Roman",
  fontSize: 20, // in px
  fontWeight: "normal",
  fontStyle: "", // "normal", "italic" or "oblique".
  cacheProperties: fabric.Object.prototype.cacheProperties.concat(
    "diameter",
    "kerning",
    "flipped",
    "fill",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "fontStyle",
    "strokeStyle",
    "strokeWidth"
  ),
  strokeStyle: null,
  strokeWidth: 0,

  initialize: function (text, options) {
    options || (options = {});
    this.text = text;

    this.callSuper("initialize", options);
    this.set("lockUniScaling", true);

    // Draw curved text here initially too, while we need to know the width and height.
    var canvas = this.getCircularText();
    this._trimCanvas(canvas);
    this.set("width", canvas.width);
    this.set("height", canvas.height);
  },

  _getFontDeclaration: function () {
    return [
      // node-canvas needs "weight style", while browsers need "style weight"
      fabric.isLikelyNode ? this.fontWeight : this.fontStyle,
      fabric.isLikelyNode ? this.fontStyle : this.fontWeight,
      this.fontSize + "px",
      fabric.isLikelyNode ? '"' + this.fontFamily + '"' : this.fontFamily,
    ].join(" ");
  },

  _trimCanvas: function (canvas) {
    var ctx = canvas.getContext("2d"),
      w = canvas.width,
      h = canvas.height,
      pix = { x: [], y: [] },
      n,
      imageData = ctx.getImageData(0, 0, w, h),
      fn = function (a, b) {
        return a - b;
      };

    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        if (imageData.data[(y * w + x) * 4 + 3] > 0) {
          pix.x.push(x);
          pix.y.push(y);
        }
      }
    }
    pix.x.sort(fn);
    pix.y.sort(fn);
    n = pix.x.length - 1;

    w = pix.x[n] - pix.x[0];
    h = pix.y[n] - pix.y[0];
    var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);

    canvas.width = w;
    canvas.height = h;
    ctx.putImageData(cut, 0, 0);
  },

  // Source: http://jsfiddle.net/rbdszxjv/
  getCircularText: function () {
    var text = this.text,
      diameter = this.diameter,
      flipped = this.flipped,
      kerning = this.kerning,
      fill = this.fill,
      inwardFacing = true,
      startAngle = 0,
      canvas = fabric.util.createCanvasElement(),
      ctx = canvas.getContext("2d"),
      cw, // character-width
      x, // iterator
      clockwise = -1; // draw clockwise for aligned right. Else Anticlockwise

    if (flipped) {
      startAngle = 180;
      inwardFacing = false;
    }

    startAngle *= Math.PI / 180; // convert to radians

    // Calc heigt of text in selected font:
    var d = document.createElement("div");
    d.style.fontFamily = this.fontFamily;
    d.style.whiteSpace = "nowrap";
    d.style.fontSize = this.fontSize + "px";
    d.style.fontWeight = this.fontWeight;
    d.style.fontStyle = this.fontStyle;
    d.textContent = text;
    document.body.appendChild(d);
    var textHeight = d.offsetHeight;
    document.body.removeChild(d);

    canvas.width = canvas.height = diameter;
    ctx.font = this._getFontDeclaration();

    // Reverse letters for center inward.
    if (inwardFacing) {
      text = text.split("").reverse().join("");
    }

    // Setup letters and positioning
    ctx.translate(diameter / 2, diameter / 2); // Move to center
    startAngle += Math.PI * !inwardFacing; // Rotate 180 if outward
    ctx.textBaseline = "middle"; // Ensure we draw in exact center
    ctx.textAlign = "center"; // Ensure we draw in exact center

    // rotate 50% of total angle for center alignment
    for (x = 0; x < text.length; x++) {
      cw = ctx.measureText(text[x]).width;
      startAngle +=
        ((cw + (x == text.length - 1 ? 0 : kerning)) /
          (diameter / 2 - textHeight) /
          2) *
        -clockwise;
    }

    // Phew... now rotate into final start position
    ctx.rotate(startAngle);

    // Now for the fun bit: draw, rotate, and repeat
    for (x = 0; x < text.length; x++) {
      cw = ctx.measureText(text[x]).width; // half letter
      // rotate half letter
      ctx.rotate((cw / 2 / (diameter / 2 - textHeight)) * clockwise);
      // draw the character at "top" or "bottom"
      // depending on inward or outward facing

      // Stroke
      if (this.strokeStyle && this.strokeWidth) {
        ctx.strokeStyle = this.strokeStyle;
        ctx.lineWidth = this.strokeWidth;
        ctx.miterLimit = 2;
        ctx.strokeText(
          text[x],
          0,
          (inwardFacing ? 1 : -1) * (0 - diameter / 2 + textHeight / 2)
        );
      }

      // Actual text
      ctx.fillStyle = fill;
      ctx.fillText(
        text[x],
        0,
        (inwardFacing ? 1 : -1) * (0 - diameter / 2 + textHeight / 2)
      );

      ctx.rotate(
        ((cw / 2 + kerning) / (diameter / 2 - textHeight)) * clockwise
      ); // rotate half letter
    }
    return canvas;
  },

  _set: function (key, value) {
    switch (key) {
      case "scaleX":
        this.fontSize *= value;
        this.diameter *= value;
        this.width *= value;
        this.scaleX = 1;
        if (this.width < 1) {
          this.width = 1;
        }
        break;

      case "scaleY":
        this.height *= value;
        this.scaleY = 1;
        if (this.height < 1) {
          this.height = 1;
        }
        break;

      default:
        this.callSuper("_set", key, value);
        break;
    }
  },

  _render: function (ctx) {
    var canvas = this.getCircularText();
    this._trimCanvas(canvas);

    this.set("width", canvas.width);
    this.set("height", canvas.height);

    ctx.drawImage(
      canvas,
      -this.width / 2,
      -this.height / 2,
      this.width,
      this.height
    );

    this.setCoords();
  },

  toObject: function (propertiesToInclude) {
    return this.callSuper(
      "toObject",
      [
        "text",
        "diameter",
        "kerning",
        "flipped",
        "fill",
        "fontFamily",
        "fontSize",
        "fontWeight",
        "fontStyle",
        "strokeStyle",
        "strokeWidth",
        "styles",
      ].concat(propertiesToInclude)
    );
  },
});

fabric.TextCurved.fromObject = function (object, callback, forceAsync) {
  return fabric.Object._fromObject(
    "TextCurved",
    object,
    callback,
    forceAsync,
    "text-curved"
  );
};

const Details = ({ addToCart, carts }) => {
  const navigate = useNavigate();
  const [alignText, setAlignText] = useState("Outside left");
  const [activeStepOne, setActiveStepOne] = useState(cardData[0].label);
  const [activeStepTwo, setActiveStepTwo] = useState(logoData[0]);
  const [errorQuantity, setErrorQuantity] = useState();
  const [selectedSparkle, setSelectedSparkle] = useState("Plain");
  const [sparkleText, setSparkleText] = useState("");
  const [selectedFitting, setSelectedFitting] = useState("Safety Pin");
  const [selectedBadge, setSelectedBadge] = useState();
  const [selectedClipart, setSelectedClipart] = useState(
    "Animals (Horse, Dogs, Pets)"
  );
  const [text, setText] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [colorOne, setColorOne] = useState({
    item: "Primary Color Choice",
    name: "",
    hex: "",
    selected: false,
  });
  const [colorTwo, setColorTwo] = useState({
    item: "Secondary Color Choice",
    name: "",
    hex: "",
    selected: false,
  });
  const [colorThree, setColorThree] = useState({
    item: "Third Color Choice",
    name: "",
    hex: "",
    selected: false,
  });
  const [selectedTails, setSelectedTails] = useState();
  const [tailTexts, setTailTexts] = useState(["", ""]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedClipartFile, setSelectedClipartFile] = useState(null);
  const [imageSize, setImageSize] = useState(50);
  const [selectedFont, setSelectedFont] = useState("arial-bold");
  const [award, setAward] = useState({
    originX: "center",
    originY: "center",
    text: "",
    top: 220,
    left: 361,
    padding: 7,
    id: "badgeAward",
    fontSize: 12.53,
    fontFamily: selectedFont,
    fill: "black",
    align: "center",
    lineHeight: 1.2,
    strokeWidth: 0,
    cursorStyle: "move",
    hoverCursor: "move",
    stroke: "white",
    type: "text",
    width: 100,
    height: 30,
    scaleX: 1,
    scaleY: 1,
    fontStyle: "normal",
    textDecoration: "",
    objectCaching: false,
    visible: true,
  });

  const [textLogo, setTextLogo] = useState({
    originX: "center",
    originY: "center",
    top: 190,
    left: 360,
    text: text,
    id: "badgeText",
    fontSize: 16,
    fontFamily: selectedFont,
    fill: "black",
    align: "center",
    lineHeight: 1,
    strokeWidth: 0,
    cursorStyle: "move",
    hoverCursor: "move",
    stroke: "white",
    type: "text",
    width: 0,
    height: 20,
    length: 0,
    scaleX: 1,
    deleted: false,
    scaleY: 1,
    fontStyle: "normal",
    textDecoration: "",
    rotation: 0,
    underlineStrokeWidth: 0,
    underlineStroke: "white",
    objectCaching: false,
    visible: true,
    kerning: 0,
    diameter: 106,
    diameterValue: 106,
  });

  const [simpleTextLogo, setSimpleTextLogo] = useState({
    originX: "center",
    originY: "center",
    top: 190,
    left: 360,
    text: text,
    id: "badgeLogoSimpleText",
    fontSize: 16,
    fontFamily: selectedFont,
    fill: "black",
    align: "center",
    lineHeight: 1,
    strokeWidth: 0,
    cursorStyle: "move",
    hoverCursor: "move",
    stroke: "white",
    type: "text",
    width: 0,
    height: 20,
    length: 0,
    scaleX: 1,
    deleted: false,
    scaleY: 1,
    fontStyle: "normal",
    textDecoration: "",
    rotation: 0,
    underlineStrokeWidth: 0,
    underlineStroke: "white",
    objectCaching: false,
    visible: true,
    // kerning: 0,
    // diameter: 105,
    // diameterValue: 105,
    // angle: 360,
  });

  const [containerDimensions, setContainerDimensions] = useState({
    width: 0,
    height: 0,
  });

  const [initialSvgScale, setInitialSvgScale] = useState(null);
  const [canvasDimensions, setCanvasDimensions] = useState({
    width: 0,
    height: 0,
  });
  const fittingOptions = [
    { id: 1, name: "Safety Pin" },
    { id: 2, name: "Sticky Tab" },
    { id: 3, name: "Bridal Hook" },
  ];

  const pricesOptions = [
    { id: 1, name: "Enhanced 5-$57.00", value: 57 },
    { id: 2, name: "Classic 5-$62.00", value: 62 },
    { id: 3, name: "Posh 6-$72.00", value: 72 },
    { id: 4, name: "Nebula 8-$87.00", value: 87 },
  ];
  const kitOptions = [
    { id: 1, name: "None", value: 0, quantity: 0 },
    { id: 2, name: "$10 for 5 Kits", value: 10, quality: 5 },
    { id: 3, name: "$15 for 6 Kits", value: 15, quantity: 6 },
    { id: 4, name: "$20 for 8 Kits", value: 20, quantity: 8 },
  ];
  const rosetteTypeOptions = [
    { id: 1, name: "Small", value: "small" },
    { id: 2, name: "Medium", value: "medium" },
    { id: 3, name: "Large", value: "large" },
    { id: 4, name: "X Large", value: "xl" },
  ];
  const [selectedPrice, setSelectedPrice] = useState(pricesOptions[0]?.value);
  const [selectedKit, setSelectedKit] = useState(kitOptions[0]?.value);
  const [rosetteType, setRosetteType] = useState(rosetteTypeOptions[0].value);
  const [canvas, setCanvas] = useState(null);
  const [heightEditor, setHeightEditor] = useState(600);
  const [canvasReady, setCanvasReady] = useState(false);
  const containerRef = useRef(null);
  const preloadSvgContent = async () => {
    for (const badge of cardData) {
      try {
        const svg = await fetch(badge.imageSrc);
        const svgText = await svg.text();
        badge.svgContent = svgText;
      } catch (error) {
        console.error(`Failed to load SVG for ${badge.label}:`, error);
      }
    }
  };

  useEffect(() => {
    const fabricCanvas = new fabric.Canvas("badge-canvas", {
      preserveObjectStacking: true,
      selection: false,
      controlsAboveOverlay: true,
      centeredScaling: true,
      allowTouchScrolling: true,
    });
    fabricCanvas.hoverCursor = "default";
    setCanvas(fabricCanvas);

    const setInitialDimensions = () => {
      if (containerRef.current) {
        const { width } = containerRef.current.getBoundingClientRect();
        const isMobile = window.innerWidth < 1024;
        const height = isMobile ? window.innerHeight * 0.5 : heightEditor;

        setCanvasDimensions({ width, height });
        fabricCanvas.setDimensions({ width, height });
      }
    };

    const handleResize = () => {
      if (containerRef.current) {
        const { width } = containerRef.current.getBoundingClientRect();
        const isMobile = window.innerWidth < 1024;
        const height = isMobile ? window.innerHeight * 0.5 : heightEditor;

        setCanvasDimensions({ width, height });
        fabricCanvas.setDimensions({ width, height });

        // Maintain SVG scale during resize
        const objects = fabricCanvas.getObjects();
        objects.forEach((obj) => {
          if (initialSvgScale) {
            const scale = isMobile ? initialSvgScale * 0.7 : initialSvgScale;
            obj.scale(scale);
            obj.center();
            obj.setCoords();
          }
        });

        fabricCanvas.renderAll();
      }
    };

    window.addEventListener("resize", handleResize);
    setInitialDimensions();
    setCanvasReady(true);

    return () => {
      fabricCanvas.dispose();
      window.removeEventListener("resize", handleResize);
    };
  }, [heightEditor, initialSvgScale]);

  // Modify the second useEffect for dimension updates
  useEffect(() => {
    const updateDimensions = async () => {
      if (containerRef.current) {
        const { width } = containerRef.current.getBoundingClientRect();
        const isMobile = window.innerWidth < 1024;
        const height = isMobile ? window.innerHeight * 0.4 : heightEditor;

        if (width) {
          setContainerDimensions({ width, height });
          if (canvas) {
            canvas.setDimensions({ width, height });

            // Scale SVG when fetching new badge
            if (selectedBadge) {
              const scaleFactor = isMobile ? 0.6 : 1;
              fetchSvgBadge(selectedBadge, scaleFactor);
            }
          }
        }
      }
    };

    window.addEventListener("resize", updateDimensions);
    updateDimensions();
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [containerRef, activeStepOne, canvas, heightEditor]);

  const handleCardClick = (e, name) => {
    e.preventDefault();
    if (
      name === "tier1" ||
      name === "tier2" ||
      name === "tier3" ||
      name === "tier4" ||
      name === "luna"
    ) {
      removeCanvasObjectsByIds(canvas, ["badge"]);
      const updatedBadges = selectedBadge.map((badge) => ({
        ...badge,
        active: badge.label === name,
      }));
      setSelectedBadge(updatedBadges);
      const activeBadge = updatedBadges.find((badge) => badge.active);
      if (activeBadge) {
        updateCanvasBadge(activeBadge.svgContent);
      }
      setActiveStepOne(name);
      arrangeByOrder();
    } else {
      removeCanvasObjectsByIds(canvas, [
        "badge",
        "badgeTails",
        "circleTails",
        "badgePrintLogo",
        "badgeLogo",
        "badgeText",
        "badgeClipart",
        "badgeAward",
        "badgeLogoSimpleText",
      ]);
      const updatedBadges = selectedBadge.map((badge) => ({
        ...badge,
        active: badge.label === name,
      }));
      setSelectedBadge(updatedBadges);
      const activeBadge = updatedBadges.find((badge) => badge.active);
      if (activeBadge) {
        updateCanvasBadge(activeBadge.svgContent);
      }
      setActiveStepOne(name);
      arrangeByOrder();
    }
  };

  useEffect(() => {
    if (!canvas) return;
    if (canvasReady && cardData) {
      preloadSvgContent().then(() => {
        fetchSvgBadge(cardData);
        // setLogoStepTwo();
      });
    }
  }, [canvasReady, cardData]);

  const fetchSvgBadge = async (cardData1, visible = true) => {
    setSelectedBadge(cardData1);

    if (canvas && cardData1) {
      const activeBadge = cardData1.find((item) => item.active);
      const svgText = activeBadge.svgContent;
      removeCanvasObjectsByIds(canvas, ["badge"]);

      fabric.loadSVGFromString(svgText, function (objects, options) {
        let svgData = fabric.util.groupSVGElements(objects, options);
        svgData.id = "badge";

        // Dynamically calculate the size based on canvas width/height
        const canvasWidth = canvas.getWidth();
        const canvasHeight = canvas.getHeight();

        // Scale to fit within canvas width and height while maintaining aspect ratio
        const scaleFactor = Math.min(
          canvasWidth / svgData.width,
          canvasHeight / svgData.height
        );
        svgData.scale(scaleFactor);

        svgData.center();
        // Set position to keep the SVG centered within the canvas
        svgData.set({
          left: (canvasWidth - svgData.width * scaleFactor) / 2,
          top: (canvasHeight - svgData.height * scaleFactor) / 2,
        });

        svgData.setCoords();

        // Set other properties to make the SVG non-interactive
        svgData.selectable = false;
        svgData.visible = visible;
        svgData.hasControls = false;
        svgData.lockMovementX = true;
        svgData.lockMovementY = true;
        svgData.lockRotation = true;
        svgData.lockScalingX = true;
        svgData.lockScalingY = true;
        svgData.sendToBack(true);

        // Add the SVG to the canvas and send to back
        canvas.add(svgData);
        canvas.sendToBack(svgData);
        canvas.renderAll();
      });
    }
    arrangeByOrder();
  };

  const removeCanvasObjectsByIds = (canvas, objectIds) => {
    objectIds.forEach((id) => {
      const obj = canvas?.getObjects().find((obj) => obj?.id === id);
      if (obj) {
        canvas.remove(obj);
        console.log(`Object with id "${id}" removed.`);
      } else {
        console.log(`Object with id "${id}" not found.`);
      }
    });
    canvas?.renderAll();
  };

  const stackingOrder = [
    "badge",
    "badgeTails",
    "circleTails",
    "badgePrintLogo",
    "badgeLogo",
    "badgeText",
    "badgeClipart",
    "badgeAward",
    "badgeLogoSimpleText",
  ];

  const arrangeByOrder = () => {
    stackingOrder.forEach((id, index) => {
      const obj = canvas?.getObjects().find((obj) => obj?.id === id);
      if (obj) {
        canvas.moveTo(obj, index);
      }
    });

    canvas?.renderAll();
  };
  useEffect(() => {
    arrangeByOrder();
  }, [canvas]);
  const [show, setShow] = useState(false);

  const [colorPickerSelectedColor, setColorPickerSelectedColor] =
    useState("Purple");
  const [colorPickerSelectedColor2, setColorPickerSelectedColor2] =
    useState("Teal");
  const [colorPickerSelectedColor3, setColorPickerSelectedColor3] =
    useState("Cyan");

  const stageRef = useRef(null);

  // const fontFamilyPosition = async () => {
  //   if (
  //     selectedFont === "arial-bold" ||
  //     selectedFont === "ldfcomicsans-bold" ||
  //     selectedFont === "gill-sans-bold" ||
  //     selectedFont === "impact"
  //   ) {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 159
  //       : text.length < 8
  //       ? 165
  //       : text.length < 10
  //       ? 169
  //       : text.length < 12
  //       ? 172
  //       : text.length < 14
  //       ? 182
  //       : text.length < 16
  //       ? 187
  //       : text.length < 18
  //       ? 190
  //       : text.length < 20
  //       ? 191
  //       : text.length < 22
  //       ? 193
  //       : text.length < 24
  //       ? 192
  //       : text.length < 28
  //       ? 196
  //       : text.length < 30
  //       ? 195
  //       : text.length < 40
  //       ? 192
  //       : text.length < 50
  //       ? 194
  //       : 196;
  //   }

  //   if (selectedFont === "arial-black") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 161
  //       : text.length < 8
  //       ? 167
  //       : text.length < 10
  //       ? 170
  //       : text.length < 12
  //       ? 176
  //       : text.length < 14
  //       ? 184
  //       : text.length < 16
  //       ? 189
  //       : text.length < 20
  //       ? 193
  //       : text.length < 22
  //       ? 194
  //       : 197;
  //   }
  //   if (selectedFont === "balloon" || selectedFont === "carlisleregular") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 158.5
  //       : text.length < 8
  //       ? 162
  //       : text.length < 10
  //       ? 166
  //       : text.length < 12
  //       ? 170
  //       : text.length < 14
  //       ? 173
  //       : text.length < 16
  //       ? 179
  //       : text.length < 18
  //       ? 182
  //       : text.length < 20
  //       ? 184
  //       : text.length < 22
  //       ? 186
  //       : text.length < 24
  //       ? 188
  //       : text.length < 26
  //       ? 189
  //       : text.length < 30
  //       ? 188
  //       : text.length < 35
  //       ? 187
  //       : text.length < 40
  //       ? 184
  //       : text.length < 40
  //       ? 186
  //       : text.length < 50
  //       ? 190
  //       : 197;
  //   }

  //   if (selectedFont === "benguiat") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 158.5
  //       : text.length < 8
  //       ? 162
  //       : text.length < 10
  //       ? 165
  //       : text.length < 12
  //       ? 169.5
  //       : text.length < 14
  //       ? 174
  //       : text.length < 16
  //       ? 179
  //       : text.length < 18
  //       ? 183
  //       : text.length < 20
  //       ? 185
  //       : text.length < 22
  //       ? 186
  //       : text.length < 24
  //       ? 188
  //       : text.length < 30
  //       ? 188
  //       : text.length < 35
  //       ? 187
  //       : text.length < 50
  //       ? 186
  //       : text.length < 57
  //       ? 191
  //       : text.length < 57
  //       ? 193
  //       : 196;
  //   }

  //   if (selectedFont === "berkshire-swash") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 159
  //       : text.length < 8
  //       ? 163
  //       : text.length < 10
  //       ? 166
  //       : text.length < 12
  //       ? 170
  //       : text.length < 14
  //       ? 175
  //       : text.length < 16
  //       ? 181
  //       : text.length < 18
  //       ? 186
  //       : text.length < 20
  //       ? 189
  //       : text.length < 34
  //       ? 190
  //       : text.length < 46
  //       ? 188
  //       : text.length < 55
  //       ? 190
  //       : 192;
  //   }
  //   if (selectedFont === "the-blacklight") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 160
  //       : text.length < 8
  //       ? 167
  //       : text.length < 10
  //       ? 176
  //       : text.length < 12
  //       ? 179
  //       : text.length < 16
  //       ? 182
  //       : text.length < 18
  //       ? 186
  //       : text.length < 20
  //       ? 190
  //       : text.length < 22
  //       ? 192
  //       : text.length < 24
  //       ? 192
  //       : 195;
  //   }
  //   if (selectedFont === "boinklet") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 158.5
  //       : text.length < 8
  //       ? 161
  //       : text.length < 10
  //       ? 163
  //       : text.length < 12
  //       ? 167
  //       : text.length < 14
  //       ? 170
  //       : text.length < 16
  //       ? 172
  //       : text.length < 18
  //       ? 177
  //       : text.length < 22
  //       ? 182
  //       : text.length < 30
  //       ? 186
  //       : text.length < 40
  //       ? 188
  //       : text.length < 50
  //       ? 190
  //       : 192;
  //   }

  //   if (selectedFont === "brush-script") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 159
  //       : text.length < 8
  //       ? 162
  //       : text.length < 10
  //       ? 165
  //       : text.length < 12
  //       ? 169
  //       : text.length < 14
  //       ? 173
  //       : text.length < 16
  //       ? 176
  //       : text.length < 18
  //       ? 180
  //       : text.length < 20
  //       ? 182
  //       : text.length < 22
  //       ? 185
  //       : text.length < 24
  //       ? 187
  //       : text.length < 30
  //       ? 188
  //       : text.length < 40
  //       ? 190
  //       : text.length < 50
  //       ? 192
  //       : 195;
  //   }

  //   if (selectedFont === "cookie") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 158.5
  //       : text.length < 8
  //       ? 161
  //       : text.length < 10
  //       ? 164
  //       : text.length < 12
  //       ? 168
  //       : text.length < 14
  //       ? 172
  //       : text.length < 16
  //       ? 175
  //       : text.length < 18
  //       ? 178
  //       : text.length < 20
  //       ? 181
  //       : text.length < 22
  //       ? 182
  //       : text.length < 24
  //       ? 182
  //       : text.length < 30
  //       ? 184
  //       : text.length < 40
  //       ? 185
  //       : text.length < 50
  //       ? 186
  //       : text.length < 60
  //       ? 188
  //       : 194;
  //   }

  //   if (selectedFont === "coopbl") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 159
  //       : text.length < 8
  //       ? 164
  //       : text.length < 10
  //       ? 168
  //       : text.length < 12
  //       ? 174
  //       : text.length < 14
  //       ? 180
  //       : text.length < 16
  //       ? 181
  //       : text.length < 18
  //       ? 190
  //       : text.length < 20
  //       ? 195
  //       : 194;
  //   }

  //   if (selectedFont === "dom-bold") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 159
  //       : text.length < 8
  //       ? 163
  //       : text.length < 10
  //       ? 166
  //       : text.length < 12
  //       ? 170
  //       : text.length < 14
  //       ? 173
  //       : text.length < 16
  //       ? 176
  //       : text.length < 18
  //       ? 181
  //       : text.length < 20
  //       ? 184
  //       : text.length < 22
  //       ? 187
  //       : text.length < 24
  //       ? 187
  //       : text.length < 30
  //       ? 188
  //       : text.length < 40
  //       ? 189
  //       : text.length < 50
  //       ? 190
  //       : 192;
  //   }
  //   if (selectedFont === "expo-bold" || selectedFont === "kabel-ultra") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 162
  //       : text.length < 8
  //       ? 169
  //       : text.length < 10
  //       ? 177
  //       : text.length < 12
  //       ? 185
  //       : text.length < 14
  //       ? 191
  //       : text.length < 16
  //       ? 194
  //       : 196;
  //   }

  //   if (selectedFont === "just-old-fashion") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 162
  //       : text.length < 8
  //       ? 169
  //       : text.length < 10
  //       ? 176
  //       : text.length < 12
  //       ? 184
  //       : text.length < 14
  //       ? 190
  //       : text.length < 16
  //       ? 194
  //       : 196;
  //   }

  //   if (selectedFont === "lucida-calligraphy-italic") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 159
  //       : text.length < 6
  //       ? 163
  //       : text.length < 8
  //       ? 170
  //       : text.length < 10
  //       ? 176
  //       : text.length < 12
  //       ? 184
  //       : text.length < 14
  //       ? 190
  //       : text.length < 16
  //       ? 194
  //       : 196;
  //   }
  //   if (selectedFont === "rocky-horror") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 162
  //       : text.length < 8
  //       ? 168
  //       : text.length < 10
  //       ? 174
  //       : text.length < 12
  //       ? 180
  //       : text.length < 14
  //       ? 187
  //       : text.length < 16
  //       ? 193
  //       : 196;
  //   }
  //   if (selectedFont === "times-new-roman" || selectedFont === "trebuchet") {
  //     return text.length < 3
  //       ? 157
  //       : text.length < 5
  //       ? 158
  //       : text.length < 6
  //       ? 159
  //       : text.length < 8
  //       ? 165
  //       : text.length < 10
  //       ? 170
  //       : text.length < 12
  //       ? 174
  //       : text.length < 14
  //       ? 182
  //       : text.length < 16
  //       ? 186
  //       : text.length < 20
  //       ? 190
  //       : text.length < 22
  //       ? 192
  //       : text.length < 30
  //       ? 194
  //       : 197;
  //   }
  // };

  // const fontSizeAwardPosition = async () => {
  //   return award.text.length < 10
  //     ? 14
  //     : award.text.length < 12
  //     ? 13.75
  //     : award.text.length < 16
  //     ? 13.5
  //     : award.text.length < 18
  //     ? 13.25
  //     : award.text.length < 20
  //     ? 13
  //     : award.text.length < 22
  //     ? 12.75
  //     : award.text.length < 24
  //     ? 12.5
  //     : award.text.length < 26
  //     ? 12.25
  //     : award.text.length < 28
  //     ? 12
  //     : award.text.length < 30
  //     ? 11.75
  //     : award.text.length < 32
  //     ? 11.5
  //     : award.text.length < 34
  //     ? 11.25
  //     : award.text.length < 36
  //     ? 11
  //     : 10.5;
  // };

  // const fontSizeTextPosition = async () => {
  //   return text.length < 10
  //     ? 16
  //     : text.length < 12
  //     ? 15.5
  //     : text.length < 14
  //     ? 15
  //     : text.length < 16
  //     ? 14.5
  //     : text.length < 18
  //     ? 14
  //     : text.length < 20
  //     ? 13.5
  //     : text.length < 22
  //     ? 13
  //     : text.length < 24
  //     ? 12.5
  //     : text.length < 26
  //     ? 12
  //     : text.length < 28
  //     ? 11.5
  //     : text.length < 30
  //     ? 11
  //     : text.length < 32
  //     ? 10.5
  //     : text.length < 34
  //     ? 10
  //     : text.length < 36
  //     ? 9.5
  //     : 9;
  // };
  // const setLogoStepTwo = async (visible = true) => {
  //   if (activeStepTwo && activeStepTwo.imageSrc) {
  //     if (canvas) {
  //       try {
  //         const response = await fetch(activeStepTwo.imageSrc);
  //         if (!response.ok) {
  //           throw new Error("Failed to fetch SVG.");
  //         }
  //         const svgText = await response.text();
  //         removeCanvasObjectsByIds(canvas, [
  //           // "badgeLogo",
  //           "badgeText",
  //           "badgePrintLogo",
  //           "badgeClipart",
  //           "badgeAward",
  //           "badgeLogoSimpleText",
  //         ]);

  //         if (activeStepTwo?.id === "logoAward") {
  //           fabric.loadSVGFromString(svgText, async (objects, options) => {
  //             let svgData = fabric.util.groupSVGElements(objects, options);
  //             const textElements = svgData
  //               .getObjects("text")
  //               .filter((obj) => obj.text === "AWARD HERE");
  //             textElements.forEach((text) => svgData.remove(text));

  //             if (selectedFile) {
  //               const textElements1 = svgData
  //                 .getObjects("text")
  //                 .filter((obj) => obj.text === "LOGO" || obj.text === "HERE");
  //               textElements1.forEach((text) => svgData.remove(text));
  //               const reader = new FileReader();
  //               reader.onload = (event) => {
  //                 const imgObj = new Image();
  //                 imgObj.src = event.target.result;
  //                 imgObj.onload = () => {
  //                   const logoCircle = svgData
  //                     .getObjects("circle")
  //                     .find((c) => c.id === "plain_border");
  //                   if (logoCircle) {
  //                     const clipCircle = new fabric.Circle({
  //                       radius: 46.36,
  //                       left: logoCircle.left,
  //                       top: logoCircle.top,
  //                       originX: "center",
  //                       originY: "center",
  //                       visible: true,
  //                     });

  //                     const scaleX = 46.36 / imgObj.width;
  //                     const scaleY = 46.36 / imgObj.height;

  //                     const fabricImage = new fabric.Image(imgObj, {
  //                       id: "badgeLogo",
  //                       left: 362,
  //                       top: 183,
  //                       originX: "center",
  //                       originY: "center",
  //                       scaleX: scaleX,
  //                       scaleY: scaleY,
  //                       clipPath: clipCircle * 2,
  //                     });

  //                     svgData.addWithUpdate(fabricImage);
  //                     canvas.renderAll();
  //                   } else {
  //                     console.warn("Circle not found for clipping.");
  //                   }
  //                 };
  //               };
  //               reader.readAsDataURL(selectedFile);
  //             }
  //             const finalGroup = new fabric.Group([svgData], {
  //               id: "badgePrintLogo",
  //               top: 141.9,
  //               left: 304.6,
  //               selectable: false,
  //               visible: visible,
  //               hasControls: false,
  //               lockMovementX: true,
  //               lockMovementY: true,
  //               lockRotation: true,
  //               lockScalingX: true,
  //               lockScalingY: true,
  //             });

  //             finalGroup.scaleToHeight(113);
  //             finalGroup.center().setCoords();
  //             finalGroup.bringToFront();
  //             canvas.add(finalGroup);
  //             const fontSizeAward = await fontSizeAwardPosition();
  //             const awardText = new fabric.Textbox(award.text || "AWARD HERE", {
  //               ...award,
  //               text: award.text || "AWARD HERE",
  //               left: award.left,
  //               top: award.top,
  //               width: award.width,
  //               fontSize: fontSizeAward,
  //               fontFamily: selectedFont,
  //               fill: award.fill,
  //               textAlign: award.align,
  //               lineHeight: award.lineHeight,
  //               originX: award.originX,
  //               originY: award.originY,
  //               selectable: false,
  //               editable: true,
  //             });

  //             canvas.add(awardText);
  //             canvas.renderAll();
  //           });
  //         } else if (activeStepTwo?.id === "logo") {
  //           fabric.loadSVGFromString(svgText, (objects, options) => {
  //             let svgData = fabric.util.groupSVGElements(objects, options);
  //             if (selectedFile) {
  //               const textElements1 = svgData
  //                 .getObjects("text")
  //                 .filter((obj) => obj.text === "LOGO" || obj.text === "HERE");
  //               textElements1.forEach((text) => svgData.remove(text));

  //               const reader = new FileReader();
  //               reader.onload = (event) => {
  //                 const imgObj = new Image();
  //                 imgObj.src = event.target.result;
  //                 imgObj.onload = () => {
  //                   const logoCircle = svgData
  //                     .getObjects("circle")
  //                     .find((c) => c.id === "plain_border");
  //                   if (logoCircle) {
  //                     const clipCircle = new fabric.Circle({
  //                       radius: 60,
  //                       left: logoCircle.left,
  //                       top: logoCircle.top,
  //                       originX: "center",
  //                       originY: "center",
  //                       visible: true,
  //                     });

  //                     const scaleX = 60 / imgObj.width;
  //                     const scaleY = 60 / imgObj.height;

  //                     const fabricImage = new fabric.Image(imgObj, {
  //                       id: "badgeLogo",
  //                       left: 360,
  //                       top: 196,
  //                       originX: "center",
  //                       originY: "center",
  //                       scaleX: scaleX,
  //                       scaleY: scaleY,
  //                       clipPath: clipCircle * 2,
  //                     });

  //                     svgData.addWithUpdate(fabricImage);
  //                     canvas.renderAll();
  //                   } else {
  //                     console.warn("Circle not found for clipping.");
  //                   }
  //                 };
  //               };
  //               reader.readAsDataURL(selectedFile);
  //             }

  //             const finalGroup = new fabric.Group([svgData], {
  //               id: "badgePrintLogo",
  //               top: 141.9,
  //               left: 304.6,
  //               selectable: false,
  //               visible: visible,
  //               hasControls: false,
  //               lockMovementX: true,
  //               lockMovementY: true,
  //               lockRotation: true,
  //               lockScalingX: true,
  //               lockScalingY: true,
  //             });

  //             finalGroup.scaleToHeight(113);
  //             finalGroup.center().setCoords();
  //             finalGroup.bringToFront();
  //             canvas.add(finalGroup);

  //             canvas.renderAll();
  //           });
  //         } else if (activeStepTwo?.id === "textAward") {
  //           fabric.loadSVGFromString(svgText, async (objects, options) => {
  //             let svgData = fabric.util.groupSVGElements(objects, options);
  //             const textElements = svgData
  //               .getObjects("text")
  //               .filter((obj) => obj.text === "YOUR TEXT HERE");
  //             textElements.forEach((text) => svgData.remove(text));
  //             const textElements1 = svgData
  //               .getObjects("text")
  //               .filter((obj) => obj.text === "AWARD" || obj.text === "HERE");
  //             textElements1.forEach((text) => svgData.remove(text));
  //             const finalGroup = new fabric.Group([svgData], {
  //               id: "badgePrintLogo",
  //               top: 141.9,
  //               left: 304.6,
  //               selectable: false,
  //               visible: visible,
  //               hasControls: false,
  //               lockMovementX: true,
  //               lockMovementY: true,
  //               lockRotation: true,
  //               lockScalingX: true,
  //               lockScalingY: true,
  //             });

  //             finalGroup.scaleToHeight(113);
  //             finalGroup.center().setCoords();
  //             finalGroup.bringToFront();
  //             canvas.add(finalGroup);
  //             const fontSizeAward = await fontSizeAwardPosition();
  //             const awardText = new fabric.Textbox(award.text || "AWARD HERE", {
  //               ...award,
  //               text: award.text || "AWARD HERE",
  //               left: 361.1,
  //               top: 200.35,
  //               width: 50,
  //               fontSize: fontSizeAward,
  //               fontFamily: selectedFont,
  //               fill: award.fill,
  //               textAlign: award.align,
  //               lineHeight: 0.8,
  //               originX: award.originX,
  //               originY: award.originY,
  //               selectable: false,
  //               editable: true,
  //             });

  //             canvas.add(awardText);
  //             const top = await fontFamilyPosition();
  //             const fontSize = await fontSizeTextPosition();
  //             let curveText = new fabric.TextCurved(text || "YOUR TEXT HERE", {
  //               ...textLogo,
  //               fontFamily: selectedFont,
  //               text: text || "YOUR TEXT HERE",
  //               top,
  //               type: "text-curved",
  //               fontSize,
  //               visible: text === "" ? false : true,
  //             });
  //             canvas.add(curveText);
  //             canvas.renderAll();
  //           });
  //         } else if (activeStepTwo?.id === "textLogo") {
  //           fabric.loadSVGFromString(svgText, async (objects, options) => {
  //             let svgData = fabric.util.groupSVGElements(objects, options);
  //             const textElements = svgData
  //               .getObjects("text")
  //               .filter((obj) => obj.text === "YOUR TEXT HERE");
  //             textElements.forEach((text) => svgData.remove(text));
  //             if (selectedFile) {
  //               const textElements1 = svgData
  //                 .getObjects("text")
  //                 .filter((obj) => obj.text === "LOGO" || obj.text === "HERE");
  //               textElements1.forEach((text) => svgData.remove(text));

  //               const reader = new FileReader();
  //               reader.onload = (event) => {
  //                 const imgObj = new Image();
  //                 imgObj.src = event.target.result;
  //                 imgObj.onload = () => {
  //                   const logoCircle = svgData
  //                     .getObjects("circle")
  //                     .find((c) => c.id === "plain_border");
  //                   if (logoCircle) {
  //                     const clipCircle = new fabric.Circle({
  //                       radius: 46.36,
  //                       left: logoCircle.left,
  //                       top: logoCircle.top,
  //                       originX: "center",
  //                       originY: "center",
  //                       visible: true,
  //                     });

  //                     const scaleX = 46.36 / imgObj.width;
  //                     const scaleY = 46.36 / imgObj.height;

  //                     const fabricImage = new fabric.Image(imgObj, {
  //                       id: "badgeLogo",
  //                       left: 360,
  //                       top: 200,
  //                       originX: "center",
  //                       originY: "center",
  //                       scaleX: scaleX,
  //                       scaleY: scaleY,
  //                       clipPath: clipCircle * 2,
  //                     });

  //                     svgData.addWithUpdate(fabricImage);
  //                     canvas.renderAll();
  //                   } else {
  //                     console.warn("Circle not found for clipping.");
  //                   }
  //                 };
  //               };
  //               reader.readAsDataURL(selectedFile);
  //             }
  //             const finalGroup = new fabric.Group([svgData], {
  //               id: "badgePrintLogo",
  //               top: 141.9,
  //               left: 304.6,
  //               selectable: false,
  //               visible: visible,
  //               hasControls: false,
  //               lockMovementX: true,
  //               lockMovementY: true,
  //               lockRotation: true,
  //               lockScalingX: true,
  //               lockScalingY: true,
  //             });

  //             finalGroup.scaleToHeight(113);
  //             finalGroup.center().setCoords();
  //             finalGroup.bringToFront();
  //             canvas.add(finalGroup);
  //             const top = await fontFamilyPosition();
  //             const fontSize = await fontSizeTextPosition();

  //             let curveText = new fabric.TextCurved(text || "YOUR TEXT HERE", {
  //               ...textLogo,
  //               fontFamily: selectedFont,
  //               fontSize,
  //               text: text || "YOUR TEXT HERE",
  //               top,
  //               type: "text-curved",
  //               visible: text === "" ? false : true,
  //             });
  //             canvas.add(curveText);
  //             canvas.renderAll();
  //           });
  //         } else if (activeStepTwo?.id === "textClipartAward") {
  //           fabric.loadSVGFromString(svgText, async (objects, options) => {
  //             let svgData = fabric.util.groupSVGElements(objects, options);

  //             const textElements = svgData
  //               .getObjects("text")
  //               .filter((obj) => obj.text === "YOUR TEXT HERE");
  //             textElements.forEach((text) => svgData.remove(text));

  //             const textElements1 = svgData
  //               .getObjects("text")
  //               .filter((obj) => obj.text === "AWARD HERE");
  //             textElements1.forEach((text) => svgData.remove(text));

  //             if (selectedClipartFile) {
  //               const textElements1 = svgData
  //                 .getObjects("text")
  //                 .filter(
  //                   (obj) => obj.text === "CLIPART" || obj.text === "HERE"
  //                 );
  //               textElements1.forEach((text) => svgData.remove(text));

  //               fabric.Image.fromURL(
  //                 selectedClipartFile.image,
  //                 (fabricImage) => {
  //                   // Dynamically adjust width and height based on the original image dimensions
  //                   const originalWidth = fabricImage.width || 100;
  //                   const originalHeight = fabricImage.height || 100;

  //                   // Desired dimensions (scaling factor or fixed size)
  //                   const desiredWidth = 60;
  //                   const desiredHeight = 60;

  //                   const scaleX = desiredWidth / originalWidth;
  //                   const scaleY = desiredHeight / originalHeight;

  //                   fabricImage.set({
  //                     id: "badgeClipart",
  //                     left: 360,
  //                     top: 185,
  //                     scaleX: scaleX,
  //                     scaleY: scaleY,
  //                     originX: "center",
  //                     originY: "center",
  //                     selectable: false,
  //                   });

  //                   canvas.add(fabricImage);
  //                   canvas.renderAll();
  //                 }
  //               );
  //             }

  //             const finalGroup = new fabric.Group([svgData], {
  //               id: "badgePrintLogo",
  //               top: 141.9,
  //               left: 304.6,
  //               selectable: false,
  //               visible: visible,
  //               hasControls: false,
  //               lockMovementX: true,
  //               lockMovementY: true,
  //               lockRotation: true,
  //               lockScalingX: true,
  //               lockScalingY: true,
  //             });

  //             finalGroup.scaleToHeight(113);
  //             finalGroup.center().setCoords();
  //             finalGroup.bringToFront();
  //             canvas.add(finalGroup);
  //             const fontSizeAward = await fontSizeAwardPosition();
  //             const awardText = new fabric.Textbox(award.text || "AWARD HERE", {
  //               ...award,
  //               text: award.text || "AWARD HERE",
  //               left: award.left,
  //               top: 219,
  //               width: award.width,
  //               fontSize: fontSizeAward,
  //               fontFamily: selectedFont,
  //               fill: award.fill,
  //               textAlign: award.align,
  //               lineHeight: award.lineHeight,
  //               originX: award.originX,
  //               originY: award.originY,
  //               selectable: false,
  //               editable: true,
  //             });

  //             canvas.add(awardText);
  //             const top = await fontFamilyPosition();
  //             const fontSize = await fontSizeTextPosition();

  //             let curveText = new fabric.TextCurved(text || "YOUR TEXT HERE", {
  //               ...textLogo,
  //               fontFamily: selectedFont,
  //               fontSize,
  //               text: text || "YOUR TEXT HERE",
  //               top,
  //               type: "text-curved",
  //               visible: text === "" ? false : true,
  //             });
  //             canvas.add(curveText);
  //             canvas.renderAll();
  //           });
  //         } else if (activeStepTwo?.id === "textLogoAward") {
  //           fabric.loadSVGFromString(svgText, async (objects, options) => {
  //             let svgData = fabric.util.groupSVGElements(objects, options);
  //             const textElements = svgData
  //               .getObjects("text")
  //               .filter((obj) => obj.text === "YOUR TEXT HERE");
  //             textElements.forEach((text) => svgData.remove(text));

  //             const textElements1 = svgData
  //               .getObjects("text")
  //               .filter((obj) => obj.text === "AWARD HERE");
  //             textElements1.forEach((text) => svgData.remove(text));
  //             if (selectedFile) {
  //               const textElements1 = svgData
  //                 .getObjects("text")
  //                 .filter((obj) => obj.text === "LOGO" || obj.text === "HERE");
  //               textElements1.forEach((text) => svgData.remove(text));

  //               const reader = new FileReader();
  //               reader.onload = (event) => {
  //                 const imgObj = new Image();
  //                 imgObj.src = event.target.result;
  //                 imgObj.onload = () => {
  //                   const logoCircle = svgData
  //                     .getObjects("circle")
  //                     .find((c) => c.id === "plain_border");
  //                   if (logoCircle) {
  //                     const clipCircle = new fabric.Circle({
  //                       radius: 30.36,
  //                       left: logoCircle.left,
  //                       top: logoCircle.top,
  //                       originX: "center",
  //                       originY: "center",
  //                       visible: true,
  //                     });

  //                     const scaleX = 51.36 / imgObj.width;
  //                     const scaleY = 30.36 / imgObj.height;

  //                     const fabricImage = new fabric.Image(imgObj, {
  //                       id: "badgeLogo",
  //                       left: 360,
  //                       top: 190,
  //                       originX: "center",
  //                       originY: "center",
  //                       scaleX: scaleX,
  //                       scaleY: scaleY,
  //                       clipPath: clipCircle * 2,
  //                     });
  //                     svgData.addWithUpdate(fabricImage);
  //                     canvas.renderAll();
  //                   } else {
  //                     console.warn("Circle not found for clipping.");
  //                   }
  //                 };
  //               };
  //               reader.readAsDataURL(selectedFile);
  //             }
  //             const finalGroup = new fabric.Group([svgData], {
  //               id: "badgePrintLogo",
  //               top: 141.9,
  //               left: 304.6,
  //               selectable: false,
  //               visible: visible,
  //               hasControls: false,
  //               lockMovementX: true,
  //               lockMovementY: true,
  //               lockRotation: true,
  //               lockScalingX: true,
  //               lockScalingY: true,
  //             });

  //             finalGroup.scaleToHeight(113);
  //             finalGroup.center().setCoords();
  //             finalGroup.bringToFront();
  //             canvas.add(finalGroup);
  //             const fontSizeAward = await fontSizeAwardPosition();
  //             const awardText = new fabric.Textbox(award.text || "AWARD HERE", {
  //               ...award,
  //               text: award.text || "AWARD HERE",
  //               left: award.left,
  //               top: 219,
  //               width: award.width,
  //               fontSize: fontSizeAward,
  //               fontFamily: selectedFont,
  //               fill: award.fill,
  //               textAlign: award.align,
  //               lineHeight: award.lineHeight,
  //               originX: award.originX,
  //               originY: award.originY,
  //               selectable: false,
  //               editable: true,
  //             });

  //             canvas.add(awardText);
  //             const top = await fontFamilyPosition();
  //             const fontSize = await fontSizeTextPosition();

  //             let curveText = new fabric.TextCurved(text || "YOUR TEXT HERE", {
  //               ...textLogo,
  //               fontFamily: selectedFont,
  //               fontSize,
  //               text: text || "YOUR TEXT HERE",
  //               top,
  //               type: "text-curved",
  //               visible: text === "" ? false : true,
  //             });
  //             canvas.add(curveText);
  //             canvas.renderAll();
  //           });
  //         } else if (activeStepTwo?.id === "text") {
  //           fabric.loadSVGFromString(svgText, async (objects, options) => {
  //             let svgData = fabric.util.groupSVGElements(objects, options);
  //             const textElements = svgData
  //               .getObjects("text")
  //               .filter(
  //                 (obj) =>
  //                   obj.text === "YOUR" ||
  //                   obj.text === "TEXT" ||
  //                   obj.text === "HERE"
  //               );
  //             textElements.forEach((text) => svgData.remove(text));
  //             const finalGroup = new fabric.Group([svgData], {
  //               id: "badgePrintLogo",
  //               top: 141.9,
  //               left: 304.6,
  //               selectable: false,
  //               visible: visible,
  //               hasControls: false,
  //               lockMovementX: true,
  //               lockMovementY: true,
  //               lockRotation: true,
  //               lockScalingX: true,
  //               lockScalingY: true,
  //             });

  //             finalGroup.scaleToHeight(113);
  //             finalGroup.center().setCoords();
  //             finalGroup.bringToFront();
  //             canvas.add(finalGroup);
  //             const fontSize = await fontSizeTextPosition();
  //             const simpleText = new fabric.Textbox(text || "YOUR TEXT HERE", {
  //               ...simpleTextLogo,
  //               text: text || "YOUR TEXT HERE",
  //               left: simpleTextLogo.left + 2,
  //               top: 197,
  //               width: 60, // Set the maximum width for the textbox
  //               fontSize: fontSize,
  //               fontFamily: selectedFont,
  //               fill: simpleTextLogo.fill,
  //               textAlign: simpleTextLogo.align || "center", // Adjust text alignment as needed
  //               lineHeight: simpleTextLogo.lineHeight || 1.2, // Adjust line height for spacing
  //               originX: simpleTextLogo.originX || "center",
  //               originY: simpleTextLogo.originY || "center",
  //               selectable: false,
  //               editable: true,
  //             });

  //             // Add the textbox to the canvas
  //             canvas.add(simpleText);

  //             canvas.renderAll();
  //           });
  //         }
  //       } catch (error) {
  //         console.error("Error loading SVG:", error);
  //       }
  //     }
  //   }
  //   arrangeByOrder();
  // };

  // const setFontStepTwo = async () => {
  //   if (activeStepTwo && activeStepTwo?.id !== "logo" && selectedFont) {
  //     if (canvas) {
  //       try {
  //         if (activeStepTwo?.id === "logoAward") {
  //           const obj = canvas
  //             ?.getObjects()
  //             .find((obj) => obj?.id === "badgeAward");
  //           if (obj) {
  //             removeCanvasObjectsByIds(canvas, ["badgeAward"]);
  //             const awardText = new fabric.Textbox(obj.text, {
  //               ...obj,
  //               fontFamily: selectedFont,
  //             });

  //             canvas.add(awardText);
  //             canvas.renderAll();
  //           }
  //         } else if (activeStepTwo?.id === "textAward") {
  //           const obj = canvas
  //             ?.getObjects()
  //             .find((obj) => obj?.id === "badgeAward");
  //           if (obj) {
  //             removeCanvasObjectsByIds(canvas, ["badgeAward"]);
  //             const awardText = new fabric.Textbox(obj.text, {
  //               ...obj,
  //               fontFamily: selectedFont,
  //             });

  //             canvas.add(awardText);
  //             canvas.renderAll();
  //           }
  //           const obj1 = canvas
  //             ?.getObjects()
  //             .find((obj) => obj?.id === "badgeText");
  //           if (obj1) {
  //             removeCanvasObjectsByIds(canvas, ["badgeText"]);
  //             const logoText = new fabric.TextCurved(text, {
  //               ...obj1,
  //               ...textLogo,
  //               text: text,
  //               type: "text-curved",
  //               visible: text === "" ? false : true,
  //               fontFamily: selectedFont,
  //             });

  //             canvas.add(logoText);
  //             canvas.renderAll();
  //           }
  //         } else if (activeStepTwo?.id === "textLogo") {
  //           const obj = canvas
  //             ?.getObjects()
  //             .find((obj) => obj?.id === "badgeText");
  //           if (obj) {
  //             removeCanvasObjectsByIds(canvas, ["badgeText"]);
  //             const logoText = new fabric.TextCurved(obj.text, {
  //               ...obj,
  //               fontFamily: selectedFont,
  //             });

  //             canvas.add(logoText);
  //             canvas.renderAll();
  //           }
  //         } else if (
  //           activeStepTwo?.id === "textClipartAward" ||
  //           activeStepTwo?.id === "textLogoAward"
  //         ) {
  //           const obj = canvas
  //             ?.getObjects()
  //             .find((obj) => obj?.id === "badgeAward");
  //           if (obj) {
  //             removeCanvasObjectsByIds(canvas, ["badgeAward"]);
  //             const awardText = new fabric.Textbox(obj.text, {
  //               ...obj,
  //               fontFamily: selectedFont,
  //             });

  //             canvas.add(awardText);
  //             canvas.renderAll();
  //           }
  //           const obj1 = canvas
  //             ?.getObjects()
  //             .find((obj) => obj?.id === "badgeText");
  //           if (obj1) {
  //             removeCanvasObjectsByIds(canvas, ["badgeText"]);
  //             const logoText = new fabric.TextCurved(obj1.text, {
  //               ...obj1,
  //               fontFamily: selectedFont,
  //             });

  //             canvas.add(logoText);
  //             canvas.renderAll();
  //           }
  //         } else if (activeStepTwo?.id === "text") {
  //           const obj = canvas
  //             ?.getObjects()
  //             .find((obj) => obj?.id === "badgeLogoSimpleText");
  //           if (obj) {
  //             removeCanvasObjectsByIds(canvas, ["badgeLogoSimpleText"]);
  //             const badgeSimpleText = new fabric.Textbox(obj.text, {
  //               ...obj,
  //               fontFamily: selectedFont,
  //             });

  //             canvas.add(badgeSimpleText);
  //             canvas.renderAll();
  //           }
  //         }
  //       } catch (error) {
  //         console.error("Error loading SVG:", error);
  //       }
  //     }
  //   } else {
  //     console.log("No active step or text source.");
  //   }
  //   arrangeByOrder();
  // };

  const updateCanvasBadge = async (svgText, visible = true) => {
    if (!canvas) return;
    // removeCanvasObjectsByIds(canvas, ["badge"]);
    fabric.loadSVGFromString(svgText, function (objects, options) {
      let svgData = fabric.util.groupSVGElements(objects, options);
      svgData.id = "badge";

      // Dynamically calculate the size based on canvas width/height
      const canvasWidth = canvas.getWidth();
      const canvasHeight = canvas.getHeight();

      // Scale to fit within canvas width and height while maintaining aspect ratio
      const scaleFactor = Math.min(
        canvasWidth / svgData.width,
        canvasHeight / svgData.height
      );
      svgData.scale(scaleFactor);

      svgData.center();
      // Set position to keep the SVG centered within the canvas
      svgData.set({
        left: (canvasWidth - svgData.width * scaleFactor) / 2,
        top: (canvasHeight - svgData.height * scaleFactor) / 2,
      });

      svgData.setCoords();

      // Set other properties to make the SVG non-interactive
      svgData.selectable = false;
      svgData.visible = visible;
      svgData.hasControls = false;
      svgData.lockMovementX = true;
      svgData.lockMovementY = true;
      svgData.lockRotation = true;
      svgData.lockScalingX = true;
      svgData.lockScalingY = true;
      svgData.sendToBack(true);

      // Add the SVG to the canvas and send to back
      canvas.add(svgData);
      canvas.sendToBack(svgData);
      canvas.renderAll();
    });
    // arrangeByOrder();
  };

  const colorChange = async (newColor, name) => {
    removeCanvasObjectsByIds(canvas, ["badge"]);
    const updatedBadges = selectedBadge.map((badge) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(badge.svgContent, "image/svg+xml");
      const elementsToChange = xmlDoc.querySelectorAll(
        ".rosette_color_1, .rosette_color_3"
      );
      elementsToChange.forEach((element) => {
        element.setAttribute("style", `fill:${newColor};`);
      });
      const updatedSvgCode = new XMLSerializer().serializeToString(xmlDoc);
      return {
        ...badge,
        svgContent: updatedSvgCode,
      };
    });

    setSelectedBadge(updatedBadges);
    const activeBadge = updatedBadges.find((badge) => badge.active);
    if (activeBadge) {
      fetchSvgBadge(updatedBadges, true); // Add updated badge
    }

    setColorPickerSelectedColor(name);
    setColorOne({
      ...colorOne,
      name: name,
      hex: newColor,
      selected: true,
    });
    arrangeByOrder();
  };

  const colorChangeRibbonTwo = async (newColor, name) => {
    removeCanvasObjectsByIds(canvas, ["badge"]);
    const updatedBadges = selectedBadge.map((badge) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(badge.svgContent, "image/svg+xml");
      const elementsToChange = xmlDoc.querySelectorAll(".rosette_color_2");
      elementsToChange.forEach((element) => {
        element.setAttribute("style", `fill:${newColor};`);
      });
      const updatedSvgCode = new XMLSerializer().serializeToString(xmlDoc);
      return {
        ...badge,
        svgContent: updatedSvgCode,
      };
    });
    setSelectedBadge(updatedBadges);
    const activeBadge = updatedBadges.find((badge) => badge.active);
    if (activeBadge) {
      updateCanvasBadge(activeBadge.svgContent);
    }
    setColorPickerSelectedColor2(name);
    setColorTwo({
      ...colorTwo,
      name: name,
      hex: newColor,
      selected: true,
    });
    arrangeByOrder();
  };

  const colorChangeRibbonThree = async (newColor, name) => {
    removeCanvasObjectsByIds(canvas, ["badge"]);
    const updatedBadges = selectedBadge.map((badge) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(badge.svgContent, "image/svg+xml");
      const elementsToChange = xmlDoc.querySelectorAll(".rosette_color_3");
      elementsToChange.forEach((element) => {
        element.setAttribute("style", `fill:${newColor};`);
      });
      const updatedSvgCode = new XMLSerializer().serializeToString(xmlDoc);
      return {
        ...badge,
        svgContent: updatedSvgCode,
      };
    });
    setSelectedBadge(updatedBadges);
    const activeBadge = updatedBadges.find((badge) => badge.active);
    if (activeBadge) {
      updateCanvasBadge(activeBadge.svgContent);
    }
    setColorPickerSelectedColor3(name);
    setColorThree({
      ...colorThree,
      name: name,
      hex: newColor,
      selected: true,
    });
    arrangeByOrder();
  };

  // const setAwardStepTwo = async () => {
  //   if (activeStepTwo && award) {
  //     if (canvas) {
  //       const obj = canvas
  //         ?.getObjects()
  //         .find((obj) => obj?.id === "badgeAward");
  //       if (obj) {
  //         removeCanvasObjectsByIds(canvas, ["badgeAward"]);
  //         const fontSizeAward = await fontSizeAwardPosition();
  //         const awardText = new fabric.Textbox(award.text || "AWARD HERE", {
  //           ...obj,
  //           text: award.text,
  //           fontSize: fontSizeAward,
  //           fontFamily: selectedFont,
  //         });

  //         canvas.add(awardText);
  //         canvas.renderAll();
  //       }
  //     }
  //   } else {
  //     console.log("No active step or text source.");
  //   }
  // };

  // useEffect(() => {
  //   setLogoStepTwo();
  // }, [activeStepTwo]);

  // const handleActiveStepTwo = async (e, data) => {
  //   e.preventDefault();
  //   setActiveStepTwo(data);
  // };

  // useEffect(() => {
  //   setLogoStepTwo();
  // }, [selectedFile]);

  // useEffect(() => {
  //   setLogoStepTwo();
  // }, [selectedClipartFile]);

  // useEffect(() => {
  //   setLogoStepTwo();
  // }, [text]);

  // useEffect(() => {
  //   setLogoStepTwo();
  // }, [text]);

  // useEffect(() => {
  //   setFontStepTwo();
  // }, [selectedFont]);

  // useEffect(() => {
  //   setAwardStepTwo();
  // }, [award]);

  // const setTailsImage = async (visible = true) => {
  //   if (selectedTails) {
  //     if (canvas) {
  //       try {
  //         const response = await fetch(selectedTails.image);

  //         if (!response.ok) {
  //           throw new Error("Failed to fetch SVG.");
  //         }

  //         const svgText = await response.text();
  //         removeCanvasObjectsByIds(canvas, ["badgeTails", "circleTails"]);
  //         fabric.loadSVGFromString(svgText, (objects, options) => {
  //           let svgData = fabric.util.groupSVGElements(objects, options);
  //           const finalGroup = new fabric.Group([svgData], {
  //             id: "badgeTails",
  //             top: 249,
  //             left: 332,
  //             selectable: false,
  //             visible: true,
  //             hasControls: false,
  //             lockMovementX: true,
  //             lockMovementY: true,
  //             lockRotation: true,
  //             lockScalingX: true,
  //             lockScalingY: true,
  //           });
  //           finalGroup.scaleToHeight(323);
  //           finalGroup.center().setCoords();
  //           const circle = new fabric.Circle({
  //             radius: 30,
  //             id: "circleTails",
  //             left: finalGroup.left,
  //             top: finalGroup.top - 40,
  //             fill: "white",
  //             selectable: false,
  //             visible: true,
  //           });
  //           circle.bringToFront();
  //           canvas.add(finalGroup);
  //           canvas.add(circle);
  //           canvas.renderAll();
  //         });
  //         arrangeByOrder();
  //       } catch (error) {
  //         console.error("Error loading SVG:", error);
  //       }
  //     }
  //   }
  // };

  // useEffect(() => {
  //   setTailsImage();
  // }, [selectedTails]);

  const canvasRef = useRef(null);

  const handleAddToCart = async (e, totalPrice, quantity, selectedKitPrice) => {
    e.preventDefault();
    if (
      quantity === 0 ||
      quantity === null ||
      quantity === undefined ||
      quantity < 1
    ) {
      setErrorQuantity("Please enter a valid quantity");
      return;
    }
    console.log("Selected File:", selectedFile); // Log the selected file for debugging

    if (canvas) {
      // Find the badge object on the canvas
      const badgeObject = canvas.getObjects().find((obj) => obj.id === "badge"); // Replace "badge" with your badge's actual identifier

      if (badgeObject) {
        // Create a temporary canvas to render only the badge object
        const tempCanvas = new fabric.StaticCanvas(null, {
          width: badgeObject.width * badgeObject.scaleX, // Use badge dimensions
          height: badgeObject.height * badgeObject.scaleY,
        });

        // Clone the badge object and add it to the temporary canvas
        badgeObject.clone((clonedBadge) => {
          clonedBadge.left = 0; // Position at (0, 0) on the new canvas
          clonedBadge.top = 0;
          tempCanvas.add(clonedBadge);
          tempCanvas.renderAll();

          // Export the temporary canvas to a data URL
          const badgeDataURL = tempCanvas.toDataURL({
            format: "png",
            quality: 1.0,
            multiplier: 2, // Adjust for higher resolution if needed
          });

          // Convert selectedFile to Base64 (if needed)
          const convertToBase64 = (file) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => resolve(reader.result);
              reader.onerror = (error) => reject(error);
            });

          // Add the new cart item with the badge image
          const addCartItem = async () => {
            const logoBase64 = selectedFile
              ? await convertToBase64(selectedFile)
              : null; // Convert selectedFile to Base64 if it exists

            const newCartItem = {
              id: Date.now(), // Unique ID for each cart item
              quantity: quantity, // Quantity
              image: badgeDataURL, // Base64 image of the badge
              name:
                cardData.find((badge) => badge.label === activeStepOne)?.name ||
                null,
              totalPrice: parseFloat(totalPrice),
              // selectedKit:
              //   kitOptions?.find((val) => selectedKit == val?.value)?.name ||
              //   "",
              // selectedType:
              //   pricesOptions?.find((val) => selectedPrice === val?.value)
              //     ?.name || "",
              colors: [
                colorOne.selected === true && colorOne,
                colorTwo.selected === true && colorTwo,
                colorThree.selected === true && colorThree,
              ].filter(Boolean),
              sparkleText,
              selectedSparkle,
              alignText,
              text: text || null,
              logo: logoBase64 || null, // Use Base64 or original file
            };

            const updatedCart =
              carts.length > 0 ? [...carts, newCartItem] : [newCartItem];
            addToCart(updatedCart);
            navigate("/cart");
          };

          addCartItem();
        });
      } else {
        console.error("Badge object not found on the canvas!");
      }
    }
  };

  const handleRosetteType = async (e, name) => {
    e.preventDefault();
    setRosetteType(name);
    if (name !== "xl" && name !== "medium") {
      setColorThree({
        ...colorThree,
        selected: false,
      });
    } else {
      if (colorThree.name !== "") {
        setColorThree({
          ...colorThree,
          selected: true,
        });
      }
    }

    if (rosetteType !== name) {
      removeCanvasObjectsByIds(canvas, [
        "badge",
        "badgeTails",
        "circleTails",
        "badgePrintLogo",
        "badgeLogo",
        "badgeText",
        "badgeClipart",
        "badgeAward",
        "badgeLogoSimpleText",
      ]);
      let firstMatchFound = false;
      const updatedBadges = selectedBadge.map((badge) => {
        // Check if the current badge matches the selected size
        if (badge.size === name && !firstMatchFound) {
          firstMatchFound = true; // Mark the first match as found
          return { ...badge, active: true }; // Make the first match active
        }
        // Make all other badges inactive
        return { ...badge, active: false };
      });
      setSelectedBadge(updatedBadges);
      const activeBadge = updatedBadges.find((badge) => badge.active);
      if (activeBadge) {
        updateCanvasBadge(activeBadge.svgContent);
      }

      setActiveStepOne(activeBadge.label);
      arrangeByOrder();
    }
  };

  return (
    <>
      <img
        src={design_ribbon}
        alt=""
        style={{ width: "100%" }}
        className="h-[30vh]  lg:h-[90vh]"
      />
      <div className="w-full flex flex-col lg:flex-row">
        <div
          className="w-full lg:w-[55%] xl:w-[72%] flex bg-white"
          style={{ position: "sticky", top: 0, zIndex: 100 }}
        >
          <div className="w-full block">
            <div
              className="px-[2px] xl:py-0 lg:py-0 md:py-[1.15vh] flex"
              style={{ position: "sticky", top: 0, zIndex: 100 }}
            >
              <div
                className="w-full  mx-auto flex h-full flex-row flex-wrap"
                ref={containerRef}
              >
                <div className="md:pt-0 flex my-0 w-full">
                  <div className="flex-grow-0 flex-shrink-0 md:basis-[80.5%] block max-w-full min-h-[1px] relative">
                    <div className="w-full m-auto border-[1px] border-dashed border-purple-500">
                      <canvas
                        id="badge-canvas"
                        ref={stageRef}
                        className="w-full h-[50vh] lg:h-full"
                      ></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-[45%] xl:w-[28%]">
          <div className="flex">
            <form
              action=""
              className="border-l-4 border-purple-500 m-0 p-0 text-[#000000] opacity-85 text-sm w-full list-none leading-7"
            >
              <StepOne
                cardData={selectedBadge}
                handleCardClick={handleCardClick}
                activeStepOne={activeStepOne}
                rosetteTypeOptions={rosetteTypeOptions}
                rosetteType={rosetteType}
                setRosetteType={setRosetteType}
                handleRosetteType={handleRosetteType}
                selectedPrice={selectedPrice}
                setSelectedPrice={setSelectedPrice}
                pricesOptions={pricesOptions}
                kitOptions={kitOptions}
                selectedKit={selectedKit}
                setSelectedKit={setSelectedKit}
              />
              {/* {(activeStepOne === "tier1" ||
                activeStepOne === "tier2" ||
                activeStepOne === "tier3" ||
                activeStepOne === "tier4" ||
                activeStepOne === "luna") && (
                <StepTwo
                  logoData={logoData}
                  activeStepTwo={activeStepTwo}
                  handleActiveStepTwo={handleActiveStepTwo}
                />
              )} */}
              {/* {(activeStepOne === "tier1" ||
                activeStepOne === "tier2" ||
                activeStepOne === "tier3" ||
                activeStepOne === "tier4" ||
                activeStepOne === "luna") && (
                <PrintLayout
                  fontFamilyData={fontFamilyData}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  imageSize={imageSize}
                  setImageSize={setImageSize}
                  award={award}
                  setAward={setAward}
                  selectedFont={selectedFont}
                  setSelectedFont={setSelectedFont}
                  activeStepTwo={activeStepTwo}
                  textLogo={textLogo}
                  setTextLogo={setTextLogo}
                  simpleTextLogo={simpleTextLogo}
                  setSimpleTextLogo={setSimpleTextLogo}
                  clipartData={clipartData}
                  setSelectedClipart={setSelectedClipart}
                  selectedClipart={selectedClipart}
                  selectedClipartFile={selectedClipartFile}
                  setSelectedClipartFile={setSelectedClipartFile}
                  text={text}
                  setText={setText}
                />
              )} */}
              <PrintLayout
                fontFamilyData={fontFamilyData}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                imageSize={imageSize}
                setImageSize={setImageSize}
                award={award}
                setAward={setAward}
                selectedFont={selectedFont}
                setSelectedFont={setSelectedFont}
                activeStepTwo={activeStepTwo}
                textLogo={textLogo}
                setTextLogo={setTextLogo}
                simpleTextLogo={simpleTextLogo}
                setSimpleTextLogo={setSimpleTextLogo}
                clipartData={clipartData}
                setSelectedClipart={setSelectedClipart}
                selectedClipart={selectedClipart}
                selectedClipartFile={selectedClipartFile}
                setSelectedClipartFile={setSelectedClipartFile}
                text={text}
                setText={setText}
              />
              <PMSColor
                randomColors={randomColors}
                colorChange={colorChange}
                show={show}
                colorPickerSelectedColor={colorPickerSelectedColor}
              />
              {/* <LeadTimeNotice /> */}

              {activeStepOne !== "tier1" && (
                <PMSColorRibbonTwo
                  randomColorsRibbonTwo={randomColors}
                  colorChangeRibbonTwo={colorChangeRibbonTwo}
                  colorPickerSelectedColor2={colorPickerSelectedColor2}
                />
              )}

              {activeStepOne !== "tier1" &&
                activeStepOne !== "tier2" &&
                activeStepOne !== "ribbons_BASIC3" &&
                activeStepOne !== "ribbons_BASIC4" &&
                activeStepOne !== "ribbons_Classic3" &&
                activeStepOne !== "ribbons_Classic4" &&
                activeStepOne !== "ribbons_Double3" &&
                activeStepOne !== "ribbons_Double4" && (
                  <PMSColorRibbonThree
                    randomColorsRibbonThree={randomColors}
                    colorChangeRibbonThree={colorChangeRibbonThree}
                    colorPickerSelectedColor3={colorPickerSelectedColor3}
                  />
                )}
              {/* <PrintRibbonTail
                ribbonTails={ribbonTails}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                selectedTails={selectedTails}
                setSelectedTails={setSelectedTails}
                tailTexts={tailTexts}
                setTailTexts={setTailTexts}
              /> */}
              {/* <RosetteFitting
                fittingOptions={fittingOptions}
                selectedFitting={selectedFitting}
                setSelectedFitting={setSelectedFitting}
              /> */}
              <Sparkles
                selectedSparkle={selectedSparkle}
                setSelectedSparkle={setSelectedSparkle}
                sparkleText={sparkleText}
                setSparkleText={setSparkleText}
                alignText={alignText}
                setAlignText={setAlignText}
              />

              <ProductPrice
                activeStepOne={activeStepOne}
                handleAddToCart={handleAddToCart}
                errorQuantity={errorQuantity}
                setErrorQuantity={setErrorQuantity}
                pricePerItem={selectedPrice}
                selectedKitPrice={selectedKit}
                kitOptions={kitOptions}
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.addToCartReducer,
  };
};
const mapDipatchToProps = (dispatch) => ({
  addToCart: (totalBill) => dispatch(addToCart(totalBill)),
});
export default connect(mapStateToProps, mapDipatchToProps)(Details);
// export default Details;
